/**
 * AUTO-GENERATED FILE, DO NOT EDIT!
 * =================================
 * This file is automatically generated through the Figma API. If you want to
 * add or update these tokens, let the DS team know through a Jira ticket.
 * Manual additions will be automatically overwritten.
 */

import classNames from 'classnames';

import type { IconProps } from '../types';

type IconPropsExtended = IconProps;

export const SettingsIcon = ({
  className,
  ...otherProps
}: IconPropsExtended): JSX.Element => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-label="SettingsIcon"
    role="img"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    className={classNames('cogs-icon', className)}
    {...otherProps}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 1c-.5 0-.922.372-.984.868l-.02.167c-.063.498-.439.89-.907 1.074a5 5 0 0 0-.197.081c-.46.202-1.003.19-1.4-.118L4.36 2.97A.991.991 0 0 0 2.97 4.36l.103.133c.308.397.32.94.118 1.4q-.044.097-.081.196c-.183.468-.576.844-1.074.907l-.167.02a.991.991 0 0 0 0 1.968l.167.02c.498.063.89.439 1.074.907q.038.099.08.196c.203.46.191 1.004-.117 1.4l-.104.134a.991.991 0 0 0 1.391 1.39l.133-.103c.397-.309.94-.32 1.4-.118q.098.043.197.081c.468.183.844.576.907 1.074l.02.167a.991.991 0 0 0 1.968 0l.02-.167c.063-.498.439-.89.907-1.074a5 5 0 0 0 .196-.08c.46-.203 1.004-.191 1.4.117l.133.104a.991.991 0 0 0 1.391-1.391l-.103-.133c-.309-.397-.32-.94-.118-1.4a5 5 0 0 0 .081-.197c.183-.468.576-.844 1.074-.907l.167-.02a.991.991 0 0 0 0-1.968l-.167-.02c-.498-.063-.89-.439-1.074-.907a5 5 0 0 0-.081-.197c-.202-.46-.19-1.003.118-1.4l.103-.132a.991.991 0 0 0-1.391-1.391l-.133.103c-.396.309-.94.32-1.4.118a5 5 0 0 0-.196-.081c-.468-.183-.844-.576-.907-1.074l-.02-.167A.99.99 0 0 0 8 1m0 10.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
      clipRule="evenodd"
    />
  </svg>
);
